import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { TenantProvider } from './contexts/TenantContext'
import ProtectedRoute from './components/auth/ProtectedRoute'
import Layout from './components/layout/Layout'
import Login from './pages/auth/Login'
import Dashboard from './pages/dashboard/Dashboard'
import ClientPortal from './pages/client/ClientPortal'
import CreatorStudio from './pages/creator/CreatorStudio'
import AdminDashboard from './pages/admin/AdminDashboard'
import MediaRecordPage from './pages/MediaRecordPage'
import NotFound from './pages/NotFound'

function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="client/*" element={<ClientPortal />} />
            <Route path="creator/*" element={<CreatorStudio />} />
            <Route path="admin/*" element={<AdminDashboard />} />
            {/* Direct media access route */}
            <Route path="media/:mediaId" element={<MediaRecordPage />} />
          </Route>
          
          {/* Catch all */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </TenantProvider>
    </AuthProvider>
  )
}

export default App 